import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-user',
  imports: [CommonModule],
  template: `
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.821 12.5366C11.1169 12.5366 10.4285 12.3278 9.84304 11.9366C9.25756 11.5454 8.80123 10.9893 8.53176 10.3388C8.26229 9.68821 8.19178 8.97236 8.32915 8.28173C8.46653 7.5911 8.80561 6.95672 9.30353 6.4588C9.80144 5.96089 10.4358 5.6218 11.1265 5.48443C11.8171 5.34705 12.5329 5.41756 13.1835 5.68703C13.8341 5.9565 14.3901 6.41283 14.7813 6.99832C15.1725 7.5838 15.3813 8.27215 15.3813 8.97631C15.3813 9.92056 15.0062 10.8261 14.3385 11.4938C13.6709 12.1615 12.7653 12.5366 11.821 12.5366ZM11.821 6.84013C11.3985 6.84013 10.9855 6.96542 10.6342 7.20014C10.2829 7.43487 10.0091 7.76849 9.84747 8.15883C9.68579 8.54916 9.64348 8.97868 9.72591 9.39306C9.80833 9.80743 10.0118 10.1881 10.3105 10.4868C10.6093 10.7856 10.9899 10.989 11.4043 11.0714C11.8187 11.1539 12.2482 11.1116 12.6385 10.9499C13.0288 10.7882 13.3625 10.5144 13.5972 10.1631C13.8319 9.81181 13.9572 9.3988 13.9572 8.97631C13.9572 8.40976 13.7321 7.86642 13.3315 7.4658C12.9309 7.06519 12.3876 6.84013 11.821 6.84013Z"
        [ngClass]="{
          'fill-black': color === 'black',
          'fill-white': color === 'white'
        }"
      />
      <path
        d="M18.4669 19.1827C18.2789 19.1802 18.0992 19.1044 17.9662 18.9714C17.8332 18.8384 17.7573 18.6587 17.7549 18.4706C17.7549 16.6193 16.7485 15.3851 11.8211 15.3851C6.89363 15.3851 5.88725 16.6193 5.88725 18.4706C5.88725 18.6595 5.81223 18.8406 5.67869 18.9741C5.54516 19.1077 5.36404 19.1827 5.17519 19.1827C4.98634 19.1827 4.80523 19.1077 4.67169 18.9741C4.53815 18.8406 4.46313 18.6595 4.46313 18.4706C4.46313 13.9609 9.61844 13.9609 11.8211 13.9609C14.0237 13.9609 19.179 13.9609 19.179 18.4706C19.1765 18.6587 19.1007 18.8384 18.9677 18.9714C18.8347 19.1044 18.655 19.1802 18.4669 19.1827Z"
        [ngClass]="{
          'fill-black': color === 'black',
          'fill-white': color === 'white'
        }"
      />
    </svg>
  `
})
export class UserComponent {
  @Input() color = 'black';
}
